import React, { useCallback } from 'react';
import { useNinjaTable } from 'components/tables/NinjaTable/useNinjaTable';
import ColumnsCustomize from './ColumnCustomize';

const TableColumnCustomization = (props) => {
  const { customizationId, onCustomizationUpdate = () => {}, removeColumns } = props;

  const { allColumns, setColumns, updateCustomColumns } = useNinjaTable();

  const handleUpdate = useCallback(
    (columnsCustomization) => {
      if (!columnsCustomization) {
        return allColumns;
      }

      const newColumns = allColumns?.filter(
        (column) => !(columnsCustomization[column.key]?.hidden === true)
      );
      setColumns(newColumns);
      onCustomizationUpdate(newColumns);
    },
    [allColumns, setColumns]
  );

  return (
    <ColumnsCustomize
      removeColumns={removeColumns}
      columns={allColumns || []}
      updateCustomColumns={updateCustomColumns}
      onUpdate={handleUpdate}
      customizationId={customizationId}
    />
  );
};

export default TableColumnCustomization;
